import { render, staticRenderFns } from "./FooterMobileComponent.vue?vue&type=template&id=0d7add80"
import script from "./FooterMobileComponent.vue?vue&type=script&lang=js"
export * from "./FooterMobileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports